import { CheckCell } from '@/pages/catalogue/Cells';
import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Col, FlexboxGrid, Form, IconButton, Input, InputNumber, InputPicker, Message, Modal, Panel, Table, Tooltip, useToaster, Whisper } from 'rsuite';
const { Column, HeaderCell, Cell } = Table;
import EditIcon from '@rsuite/icons/Edit';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import globalIP from '@/GlobelIP';
import { Icon } from '@rsuite/icons';
import PackageLoadability from '@/pages/tables/members/CreateProduct/PackageLoadability';
const ipp = globalIP;

const ShowVariantModal = ({
    varOpen,
    setVarOpen,
    vardata,
    selectedVarItems,
    setSelectedVarItems,
    label,
    fetchData,
    fetchDataVData
}) => {
    const [showIcon, setShowIcon] = useState(false);
    const handleToggleIcon = () => {
        setShowIcon(!showIcon);
    };
    const handleCheckboxChange1 = (value, checked) => {
        if (checked) {
            setSelectedVarItems(prevSelectedItems => [...prevSelectedItems, value]);
        } else {
            setSelectedVarItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
        }
    };
    const handleCheckAllT = (value, checked) => {
        if (checked) {
            setSelectedVarItems(prevState => [
                ...prevState,
                ...vardata.map(row => row.id).filter(id => !prevState.includes(id)) // Only add if not already in prevState
            ]);
        } else {
            setSelectedVarItems(prevState =>
                prevState.filter(item => !vardata.some(row => row.id === item))
            );
        }
    };

    const handleOpencbm = prcd => {
        setCbmEditData(prcd);
        setOpencbm(true);
    };


    const addPackaging = () => {
        setData5(prevData => {
            const newPackaging = {
                CartonType: '',
                ProductCode: '0',
                Carton_Unit: '',
                Carton_Length: 0,
                Carton_Width: 0,
                Carton_Thick: 0,
                Carton_CBM: 0,
                Carton_PCS: 0,
                Carton_CBMperpc: 0,
                Carton_GrsWt: 0
            };

            return {
                ...prevData,
                Packaging: [...prevData.Packaging, newPackaging]
            };
        });
    };


    const cartontype = [
        { label: 'Master', value: 'master' },
        { label: 'Inner', value: 'inner' }
    ];

    const siii = [
        { label: 'CM', value: 'cm' },
        { label: 'Inch', value: 'inch' }
    ];
    const toaster = useToaster();
    const [opencbm, setOpencbm] = useState(false);
    const [cbmeditdata, setCbmEditData] = useState('');
    const [totalcbm1, setTotalCbm] = useState(0);
    const [totalcft, setTotalCFT] = useState(0);
    const [feet20, setFeet20] = useState<any | null>(0);
    const [feet40, setFeet40] = useState<any | null>(0);
    const [feet20hc, setFeet20hc] = useState<any | null>(0);
    const handleClosecbm = () => setOpencbm(false);
    const [data5, setData5] = useState({
        Total_CBM: 0,
        Total_CFT: 0,
        TwentyFT: '',
        FortyFT: '',
        FortyHQ: '',
        Packaging: [
            {
                CartonType: 'master',
                ProductCode: '',
                Carton_Unit: 'inch',
                Carton_Length: 0,
                Carton_Width: 0,
                Carton_Thick: 0,
                Carton_CBM: 0,
                Carton_PCS: 0,
                Carton_CBMperpc: 0,
                Carton_GrsWt: 0
            }
        ]
    });


    const [productdata, setProductData] = useState([]);
    useEffect(() => {
        if (cbmeditdata) {
            fetchDatatPdata();
        }
    }, [cbmeditdata]);
    const fetchDatatPdata = async () => {
        try {
            const response = await fetch(
                `${ipp}/api/variant-products?populate=*&filters[id][$eq]=${cbmeditdata}`
            );
            const json = await response.json();
            // console.log('pdata :', json);
            setProductData(json.data);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    useEffect(() => {
        if (productdata) {
            fetchDatatset();
        }
    }, [productdata]);

    const fetchDatatset = async () => {
        if (productdata && productdata.length > 0) {
            const firstProduct = productdata[0].attributes;

            setTotalCbm(firstProduct.Total_CBM);
            setTotalCFT(firstProduct.Total_CFT);
            setFeet20(firstProduct.TwentyFT);
            setFeet40(firstProduct.FortyFT);
            setFeet20hc(firstProduct.FortyHQ);

            // Set Packaging data
            setData5(prevData => ({
                ...prevData,
                Packaging: firstProduct.Packaging || [] // Assuming productdata has a property Packaging
            }));
        }
    };

    const submitpack = e => {
        e.preventDefault();
        const formData = new FormData();
        // Create an updatedCategory object with the modified data
        // console.log('Packing :', productdata);
        data5.Packaging.forEach((pack, index) => {
            formData.append(
                `Packaging[${index + 1}][ProductCode]`,
                productdata[0].attributes.ProductCode
            );
            formData.append(`Packaging[${index}][CartonType]`, pack.CartonType);
            formData.append(`Packaging[${index}][Carton_Unit]`, pack.Carton_Unit);
            formData.append(`Packaging[${index}][Carton_Length]`, String(pack.Carton_Length));
            formData.append(`Packaging[${index}][Carton_Width]`, String(pack.Carton_Width));
            formData.append(`Packaging[${index}][Carton_Thick]`, String(pack.Carton_Thick));
            formData.append(`Packaging[${index}][Carton_CBM]`, String(pack.Carton_CBM));
            formData.append(`Packaging[${index}][Carton_PCS]`, String(pack.Carton_PCS));
            formData.append(`Packaging[${index}][Carton_CBMperpc]`, String(pack.Carton_CBMperpc));
            formData.append(`Packaging[${index}][Carton_GrsWt]`, String(pack.Carton_GrsWt));
        });
        formData.append(
            'data',
            JSON.stringify({
                ...data5,
                Total_CBM: totalcbm1,
                Total_CFT: totalcft,
                TwentyFT: String(feet20),
                FortyFT: String(feet40),
                FortyHQ: String(feet20hc)
            })
        );

        // Send a PUT request to the API
        fetch(`${ipp}/api/variant-products/${cbmeditdata}`, {
            method: 'PUT', // Use PUT for updating
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                handleClosecbm();
                fetchData();
                fetchDataVData(data.data.attributes.Variant_Id);
                toaster.push(
                    <Message showIcon type="success">
                        CBM Changes Successfully.
                    </Message>,
                    { placement: 'topEnd' }
                );
            })
            .catch(error => {
                console.error(error);
            });
    };
    return (
        <>

            <Modal open={varOpen} onClose={() => setVarOpen(false)} size="lg" backdrop="static">
                <Modal.Header>
                    <Modal.Title>
                        <b>Variants</b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table height={250} data={vardata} bordered cellBordered rowHeight={60}>
                        <Column width={50} align="center">
                            <HeaderCell style={{ padding: 0 }}>
                                <div style={{ lineHeight: '40px' }}>
                                    <Checkbox
                                        inline
                                        // checked={selectedItems.length === vardata.length}
                                        checked={vardata.every(item => selectedVarItems.includes(item.id))}
                                        indeterminate={vardata.some(item => selectedVarItems.includes(item.id))}
                                        // indeterminate={
                                        //   selectedItems.length > 0 && selectedItems.length < vardata.length
                                        // }
                                        onChange={handleCheckAllT}
                                    />
                                </div>
                            </HeaderCell>
                            <CheckCell
                                dataKey="id"
                                checkedKeys={selectedVarItems}
                                onChange={(rowId, checked) => handleCheckboxChange1(rowId, checked)}
                                rowData={undefined}
                            />
                        </Column>
                        <Column width={100} align="center">
                            <HeaderCell>
                                <b>Image</b>
                            </HeaderCell>
                            <Table.Cell>
                                {rowData => {
                                    // Define a function to show the enlarged image on hover
                                    const renderTooltip = imageSrc => (
                                        <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                                            <img
                                                src={imageSrc}
                                                alt="Product Image"
                                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                            />
                                        </Tooltip>
                                    );
                                    return (
                                        <Whisper
                                            trigger="hover"
                                            placement="right"
                                            speaker={renderTooltip(
                                                `${ipp}${rowData.attributes.CoverImage.data.attributes.url}`
                                            )}
                                        >
                                            <img
                                                src={`${ipp}${rowData.attributes.CoverImage.data.attributes.url}`}
                                                alt="Product Image"
                                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                            />
                                        </Whisper>
                                    );
                                }}
                            </Table.Cell>
                        </Column>
                        <Column width={100} align="center">
                            <HeaderCell>
                                <b>Alias Code</b>
                            </HeaderCell>
                            <Cell dataKey={'attributes.ProductId'} />
                        </Column>
                        <Column flexGrow={1} align="center" fullText>
                            <HeaderCell>
                                <b>Description</b>
                            </HeaderCell>
                            <Cell dataKey={'attributes.Description'} />
                        </Column>
                        <Column width={200} align="center">
                            <HeaderCell>
                                <b>Product Name</b>
                            </HeaderCell>
                            <Cell dataKey={'attributes.ProductName'} />
                        </Column>
                        <Column width={100} align="center">
                            <HeaderCell>Finish</HeaderCell>
                            <Cell dataKey={'attributes.FinishName'} />
                        </Column>
                        <Column width={80} align="center">
                            <HeaderCell>Color</HeaderCell>
                            <Cell dataKey={'attributes.ColorName'} />
                        </Column>
                        <Column width={80} align="center">
                            <HeaderCell>
                                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                                    <b>{label[0]?.attributes.cbm}</b>
                                    <div
                                        onClick={handleToggleIcon}
                                        style={{ marginLeft: '5px', fontSize: '15px', cursor: 'pointer' }}
                                    >
                                        {showIcon ? <Icon as={CloseOutlineIcon} /> : <Icon as={EditIcon} />}
                                    </div>
                                </div>
                            </HeaderCell>
                            <Cell>
                                {rowData => (
                                    <div>
                                        {rowData.attributes.Total_CBM} {/* Always show CBM value */}
                                        {showIcon && (
                                            <IconButton
                                                icon={<EditIcon />}
                                                circle
                                                size="xs"
                                                style={{ marginLeft: '5px' }}
                                                onClick={() => handleOpencbm(rowData.id)}
                                            />
                                        )}
                                    </div>
                                )}
                            </Cell>
                        </Column>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setVarOpen(false)} appearance="primary" color="cyan">
                        Confirm Selection
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal size="full" open={opencbm} onClose={handleClosecbm} backdrop="static">
                <Modal.Body>
                    <PackageLoadability
                        {...{
                            data5,
                            setData5,
                            //data of Inputes
                            cartontype,
                            siii,
                            //Value of the InputeNumber
                            totalcbm1,
                            totalcft,
                            feet20,
                            feet40,
                            feet20hc,
                            //Function to handle inputes
                            handleInputChange:()=>{},
                            label,
                            addPackaging,
                            setTotalCbm,
                            setTotalCFT,
                            setFeet20,
                            setFeet40,
                            setFeet20hc
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClosecbm} appearance="default" active>
                        Cancel
                    </Button>
                    <Button onClick={submitpack} appearance="primary" color="cyan">
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ShowVariantModal